document.addEventListener("DOMContentLoaded", function () {
  function updateCountdownAndDelivery() {
    const now = new Date();
    const cutoffHour = 09; // 00 Uhr
    const cutoffMinute = 00; // 9:00 Uhr

    // Feiertage für Baden-Württemberg (2026, 2027)
    const holidays = [
      "2026-01-01", "2026-01-06", "2026-04-03", "2026-04-06", "2026-05-01",
      "2026-05-14", "2026-05-25", "2026-06-04", "2026-10-03", "2026-11-01",
      "2026-12-25", "2026-12-26",

      "2027-01-01", "2027-01-06", "2027-03-26", "2027-03-29", "2027-05-01",
      "2027-05-06", "2027-05-17", "2027-05-27", "2027-10-03", "2027-11-01",
      "2027-12-25", "2027-12-26"
    ];

    const isHoliday = (date) => {
      const dateString = date.toISOString().split("T")[0];
      return holidays.includes(dateString);
    };

    // Überprüfen, ob das Produkt auf Lager ist
    const deliveryInfoElement = document.getElementById("delivery-info");
    const stockStatus = deliveryInfoElement?.getAttribute("data-stock");

    if (stockStatus === "out-of-stock") {
      deliveryInfoElement.innerHTML = '<strong class="out-of-stock">Nicht auf Lager</strong>';
      return;
    }

    // Cutoff-Time heute
    let cutoffTime = new Date();
    cutoffTime.setHours(cutoffHour, cutoffMinute, 0, 0);

    // Versandstart bestimmen
    let shippingStartDate = new Date(now);

    // Wenn nach der Cutoff-Time, Versand startet (theoretisch) am nächsten Tag
    if (now > cutoffTime) {
      shippingStartDate.setDate(shippingStartDate.getDate() + 1);
    }

    // Versand darf nicht an Samstagen, Sonntagen oder Feiertagen starten
    while (
      shippingStartDate.getDay() === 0 || // Sonntag
      shippingStartDate.getDay() === 6 || // Samstag
      isHoliday(shippingStartDate)        // Feiertag
    ) {
      shippingStartDate.setDate(shippingStartDate.getDate() + 1);
    }

    // 📦 Frühester Liefertag: +1 Werktag ab Versandstart
    let firstDeliveryDate = new Date(shippingStartDate);
    firstDeliveryDate.setDate(firstDeliveryDate.getDate() + 1);
    while (
      firstDeliveryDate.getDay() === 0 || // Sonntag
      isHoliday(firstDeliveryDate)        // Feiertag
    ) {
      firstDeliveryDate.setDate(firstDeliveryDate.getDate() + 1);
    }

    // 📦 Spätester Liefertag: +1 weiterer Werktag
    let secondDeliveryDate = new Date(firstDeliveryDate);
    secondDeliveryDate.setDate(secondDeliveryDate.getDate() + 1);
    while (
      secondDeliveryDate.getDay() === 0 || // Sonntag
      isHoliday(secondDeliveryDate)        // Feiertag
    ) {
      secondDeliveryDate.setDate(secondDeliveryDate.getDate() + 1);
    }

    // Kurzformen für Tage & Monate
    const weekdaysShort = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
    const monthsShort = ["Jan", "Feb", "Mrz", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];

    const firstDayShort = weekdaysShort[firstDeliveryDate.getDay()];
    const firstMonthShort = monthsShort[firstDeliveryDate.getMonth()];
    const secondDayShort = weekdaysShort[secondDeliveryDate.getDay()];
    const secondMonthShort = monthsShort[secondDeliveryDate.getMonth()];

    const firstDayNum = firstDeliveryDate.getDate();
    const secondDayNum = secondDeliveryDate.getDate();

    // Format: "Do 27 Nov - Fr 28 Nov"
    const deliveryRangeFormatted = `${firstDayShort} ${firstDayNum} ${firstMonthShort} - ${secondDayShort} ${secondDayNum} ${secondMonthShort}`;

    // Countdown berechnen
    let diff;
    if (now < cutoffTime) {
      diff = cutoffTime - now;
    } else {
      const nextCutoff = new Date(cutoffTime);
      nextCutoff.setDate(nextCutoff.getDate() + 1);
      diff = nextCutoff - now;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

    // HTML-Inhalt aktualisieren
    const deliveryDateElement = document.getElementById("delivery-date");
    const countdownElement = document.getElementById("countdown");

    if (deliveryDateElement) {
      deliveryDateElement.textContent = deliveryRangeFormatted;
    }

    if (countdownElement) {
      countdownElement.textContent = `${hours} Stdn. ${minutes} Min.`;
    }
  }

  // Countdown jede Sekunde aktualisieren
  updateCountdownAndDelivery();
  setInterval(updateCountdownAndDelivery, 1000);
});